/**
 * @generated SignedSource<<f44965bd1f65a233246ed94b4be6265f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryEditScreenMergeMutation$variables = {
  id: string;
  targetTodoCategoryId: string;
};
export type TodoCategoryEditScreenMergeMutation$data = {
  readonly todoCategory: {
    readonly merge: {
      readonly id: string;
    };
  } | null;
};
export type TodoCategoryEditScreenMergeMutation = {
  response: TodoCategoryEditScreenMergeMutation$data;
  variables: TodoCategoryEditScreenMergeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetTodoCategoryId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoCategoryMutation",
    "kind": "LinkedField",
    "name": "todoCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "targetTodoCategoryId",
            "variableName": "targetTodoCategoryId"
          }
        ],
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "merge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryEditScreenMergeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryEditScreenMergeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2d799978858b1bedd34b55a46b4f0bb",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryEditScreenMergeMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryEditScreenMergeMutation(\n  $id: ID!\n  $targetTodoCategoryId: ID!\n) {\n  todoCategory(id: $id) {\n    merge(targetTodoCategoryId: $targetTodoCategoryId) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f5c1309cf818f3fd6a987d86d07460d";

export default node;
